import { type FC } from "react";
import classNames from "classnames";
import {
  LOGO_MEDIAS,
  LOGO_MEDIAS_BUSINESS,
  LOGO_MEDIAS_GROWTH,
  LOGO_MEDIAS_PLUS,
  LOGO_MEDIAS_PLUS_BUSINESS,
} from "~/utils/url/staticResources";
import { HOMEPAGE } from "~/utils/url/staticUrls";

type Props = JSX.IntrinsicElements["img"] & {
  variant: MediasVariant;
  href?: boolean;
};

export type MediasVariant = "general" | "plus" | "business" | "plus-business" | "growth";

const LOGO_URLS: Dictionary<string> = {
  general: LOGO_MEDIAS,
  plus: LOGO_MEDIAS_PLUS,
  business: LOGO_MEDIAS_BUSINESS,
  "plus-business": LOGO_MEDIAS_PLUS_BUSINESS,
  plusbusiness: LOGO_MEDIAS_PLUS_BUSINESS,
  growth: LOGO_MEDIAS_GROWTH,
};

export const MediasLogo: FC<Props> = ({ variant, className, alt, href, ...props }) => {
  return (
    <>
      {href ? (
        <a href={HOMEPAGE}>
          <img
            data-test-id={"logo-medias"}
            data-test-variant={variant}
            src={LOGO_URLS[variant]}
            className={classNames(`medias-logo-text medias-logo-text--${variant}`, className)}
            alt={alt ?? ""}
            {...props}
          />
        </a>
      ) : (
        <img
          data-test-id={"logo-medias"}
          data-test-variant={variant}
          src={LOGO_URLS[variant]}
          className={classNames(`medias-logo-text medias-logo-text--${variant}`, className)}
          alt={alt ?? ""}
          {...props}
        />
      )}
    </>
  );
};
